import { all, takeEvery, put, call } from 'redux-saga/effects'
import { notification } from 'antd'
import actions from './actions'
import { SAVE_200_MSG, SAVE_200_DESC, DEL_200_MSG, DEL_200_DESC } from '../../constants'
import { find, save, remove, list2 } from '../../services/inventoryServiceLabor'

// function* fetchInventoryServiceLaborsRefresh() {
//   const fe = JSON.parse(localStorage.getItem('fetchInventoryServiceLabors'))
//   if (fe == null) {
//     fe.size = localStorage.getItem('pageSize') || 15
//     fe.index = 0
//     fe.searchTerm = '%20'
//     fe.orderBy = '%20'
//   }
//   yield put({
//     type: actions.REQUESTING,
//   })
//   const result = yield call(list, fe.size, fe.index, fe.searchTerm, fe.orderBy)
//   yield put({
//     type: actions.LIST_INVENTORYSERVICELABOR,
//     result,
//   })
// }

// function* fetchInventoryServiceLabors({ size, index, searchTerm, orderBy }) {
//   if (!size && !index && !searchTerm && !orderBy) {
//     const fe = null
//     if (fe != null) {
//       size = fe.size || 15
//       index = fe.index || 0
//       searchTerm = fe.searchTerm || '%20'
//       orderBy = fe.orderBy || '%20'
//     } else {
//       size = size || localStorage.getItem('pageSize') || 15
//       index = 0
//       searchTerm = '%20'
//       orderBy = '%20'
//     }
//   }
//   localStorage.setItem(
//     'fetchInventoryServiceLabors',
//     JSON.stringify({ size, index, searchTerm, orderBy }),
//   )
//   yield put({
//     type: actions.REQUESTING,
//   })
//   const result = yield call(list, size, index, searchTerm, orderBy)
//   yield put({
//     type: actions.LIST_INVENTORYSERVICELABOR,
//     result,
//   })
// }

function* fetchInventoryServiceLaborEdit({ id }) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(find, id)
  yield put({
    type: actions.EDIT_INVENTORYSERVICELABOR,
    result,
  })
}

function* fetchInventoryServiceLaborSave(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(save, values)
  if (result !== null) {
    notification.success({ message: SAVE_200_MSG, description: SAVE_200_DESC })
  }
  yield put({
    type: actions.SAVE_INVENTORYSERVICELABOR_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_INVENTORYSERVICELABORS,
  })
}

function* fetchInventoryServiceLaborDelete(values) {
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(remove, values)
  if (result !== null) {
    notification.success({ message: DEL_200_MSG, description: DEL_200_DESC })
  }
  yield put({
    type: actions.DELETE_INVENTORYSERVICELABOR_RECIEVED,
    result,
  })
  yield put({
    type: actions.RE_FETCH_INVENTORYSERVICELABORS,
  })
}

function* fetchInventoryServiceLaborsFilter({
  size,
  index,
  searchTerm,
  orderBy,
  repairCode,
  repairDescription,
  className,
  mlfbNumber,
}) {
  const t = localStorage.getItem('fetchInventoryServiceLaborsFilter')
  if (t !== undefined && t != null) {
    try {
      const fe = JSON.parse(t)
      if (fe != null) {
        if (size === undefined) size = fe.size || size
        if (index === undefined) index = fe.index || index
        if (searchTerm === undefined) searchTerm = fe.searchTerm || searchTerm
        if (orderBy === undefined) orderBy = fe.orderBy || orderBy
        className = fe.className || className
        repairCode = fe.repairCode || repairCode
        repairDescription = fe.repairDescription || repairDescription
        className = fe.className || className
        mlfbNumber = fe.mlfbNumber || mlfbNumber
      }
    } catch (e) {
      console.log(e)
    }
  }
  size = size || localStorage.getItem('pageSize') || 15
  try {
    localStorage.setItem(
      'fetchInventoryServiceLaborsFilter',
      JSON.stringify({
        size,
        index,
        searchTerm,
        orderBy,
        repairCode,
        repairDescription,
        className,
        mlfbNumber,
      }),
    )
  } catch (e) {
    console.log(e)
  }
  yield put({
    type: actions.REQUESTING,
  })
  const result = yield call(
    list2,
    size,
    index,
    searchTerm,
    orderBy,
    repairCode,
    repairDescription,
    className,
    mlfbNumber,
  )
  yield put({
    type: actions.LIST_INVENTORYSERVICELABOR,
    result,
  })
}

export default function* rootSaga() {
  yield all([
    // takeEvery(actions.FETCH_INVENTORYSERVICELABORS, fetchInventoryServiceLabors),
    takeEvery(actions.FETCH_INVENTORYSERVICELABOR, fetchInventoryServiceLaborEdit),
    takeEvery(actions.SAVE_INVENTORYSERVICELABOR, fetchInventoryServiceLaborSave),
    takeEvery(actions.DELETE_INVENTORYSERVICELABOR, fetchInventoryServiceLaborDelete),
    takeEvery(actions.RE_FETCH_INVENTORYSERVICELABORS, fetchInventoryServiceLaborsFilter),
    takeEvery(actions.FETCH_INVENTORYSERVICELABORS_FILTER, fetchInventoryServiceLaborsFilter),
  ])
}
